'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Error({ error }: { error: Error; reset: () => void }) {
  const router = useRouter();

  useEffect(() => {
    console.error('Uncaught error:', error);
    // Redirect to tryon error page
    router.replace('/tryon?error=uncaught');
  }, [error, router]);

  // Show loading while redirecting
  return null;
}
